import {ForwardedRef, useEffect, useRef, useState} from "react";

import {useCombinedRefs} from "@pg-mono/hooks";

interface IProps {
    autoHeight: boolean;
    initialHeight: number;
    wrapperRef: ForwardedRef<HTMLDivElement>;
}

export function useAutoHeight(props: IProps) {
    const {autoHeight = false, initialHeight = 0, wrapperRef} = props;
    const internalWrapperRef = useRef<HTMLDivElement | null>(null);
    const [calculatedHeight, setCalculatedHeight] = useState<number>(initialHeight);
    const combinedWrapperRef = useCombinedRefs<HTMLDivElement>(internalWrapperRef, wrapperRef);
    const animationFrameRef = useRef<number | null>(null);

    useEffect(() => {
        if (!autoHeight || !internalWrapperRef.current) return;

        const updateHeight = () => {
            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
            }

            animationFrameRef.current = requestAnimationFrame(() => {
                if (internalWrapperRef.current?.parentElement) {
                    const parentHeight = internalWrapperRef.current.parentElement.clientHeight;
                    const rect = internalWrapperRef.current.getBoundingClientRect();
                    const parentRect = internalWrapperRef.current.parentElement.getBoundingClientRect();

                    const offsetFromParentTop = rect.top - parentRect.top;
                    const availableHeight = parentHeight - offsetFromParentTop;

                    setCalculatedHeight(Math.max(0, availableHeight));
                }
                animationFrameRef.current = null;
            });
        };

        updateHeight();

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });

        if (internalWrapperRef.current.parentElement) {
            resizeObserver.observe(internalWrapperRef.current.parentElement);
        }

        return () => {
            resizeObserver.disconnect();

            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
        };
    }, [autoHeight]);

    const currentHeight = autoHeight ? calculatedHeight : initialHeight;

    return {
        combinedWrapperRef,
        currentHeight
    };
}
import {ForwardedRef, useEffect, useRef, useState} from "react";

import {useCombinedRefs} from "@pg-mono/hooks";

interface IProps {
    autoHeight: boolean;
    initialHeight: number;
    wrapperRef: ForwardedRef<HTMLDivElement>;
}

export function useAutoHeight(props: IProps) {
    const {autoHeight = false, initialHeight = 0, wrapperRef} = props;
    const internalWrapperRef = useRef<HTMLDivElement | null>(null);
    const [calculatedHeight, setCalculatedHeight] = useState<number>(initialHeight);
    const combinedWrapperRef = useCombinedRefs<HTMLDivElement>(internalWrapperRef, wrapperRef);
    const animationFrameRef = useRef<number | null>(null);

    useEffect(() => {
        if (!autoHeight || !internalWrapperRef.current) return;

        const updateHeight = () => {
            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
            }

            animationFrameRef.current = requestAnimationFrame(() => {
                if (internalWrapperRef.current?.parentElement) {
                    const parentHeight = internalWrapperRef.current.parentElement.clientHeight;
                    const rect = internalWrapperRef.current.getBoundingClientRect();
                    const parentRect = internalWrapperRef.current.parentElement.getBoundingClientRect();

                    const offsetFromParentTop = rect.top - parentRect.top;
                    const availableHeight = parentHeight - offsetFromParentTop;

                    setCalculatedHeight(Math.max(0, availableHeight));
                }
                animationFrameRef.current = null;
            });
        };

        updateHeight();

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });

        if (internalWrapperRef.current.parentElement) {
            resizeObserver.observe(internalWrapperRef.current.parentElement);
        }

        return () => {
            resizeObserver.disconnect();

            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
        };
    }, [autoHeight]);

    const currentHeight = autoHeight ? calculatedHeight : initialHeight;

    return {
        combinedWrapperRef,
        currentHeight
    };
}
